import { ReactNode } from "react"
import { useSortable } from "@dnd-kit/sortable"
import { CSS } from "@dnd-kit/utilities"
import { Button } from "@ui/shad"
import { GripHorizontal, X } from "lucide-react"

export interface SortableItemProps {
  id: string | number
  children: ReactNode
  onDelete?: () => void
  deletable?: boolean
  sortable?: boolean
  className?: string
}

export function SortableItem({
  id,
  children,
  onDelete,
  deletable = true,
  sortable = true,
  className,
}: SortableItemProps) {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({ id })

  const style = sortable
    ? {
        transform: CSS.Transform.toString(transform),
        transition,
        opacity: isDragging ? 0.5 : 1,
      }
    : undefined

  return (
    <div ref={setNodeRef} style={style} className={`flex items-center justify-between gap-1 ${className || ""}`}>
      <div className="flex flex-1 items-center gap-2">
        {sortable && (
          <Button
            variant="ghost"
            size="iconXs"
            className="cursor-grab active:cursor-grabbing"
            {...attributes}
            {...listeners}
          >
            <GripHorizontal className="text-icon" />
          </Button>
        )}
        {children}
      </div>
      {deletable && onDelete && (
        <Button variant="ghost" size="iconXs" onClick={onDelete}>
          <X className="text-icon" />
        </Button>
      )}
    </div>
  )
}
